import { useEffect, useRef, useState } from "react";
import { checkEmailHealth, fetchEmailVariables, previewEmailTemplate } from "./api";
import { EmailFormData, EmailPreviewResponse, EmailVariablesCatalog } from "./types";

export function useEmailVariables() {
  const [catalog, setCatalog] = useState<EmailVariablesCatalog | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let alive = true;
    fetchEmailVariables()
      .then((data) => alive && setCatalog(data))
      .catch(() => alive && setError(true));
    return () => {
      alive = false;
    };
  }, []);

  return { catalog, error };
}

export function useEmailPreview(
  params: { agendamentoId?: string; assunto: string; corpo: string } | null,
  delay = 500,
) {
  const [preview, setPreview] = useState<EmailPreviewResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const requestId = useRef(0);
  const key = params ? JSON.stringify(params) : "";

  useEffect(() => {
    if (!params) return;
    const id = ++requestId.current;
    setLoading(true);
    const timer = setTimeout(() => {
      previewEmailTemplate(params)
        .then((data) => {
          if (id !== requestId.current) return;
          setPreview(data);
          setError(false);
        })
        .catch(() => id === requestId.current && setError(true))
        .finally(() => id === requestId.current && setLoading(false));
    }, delay);
    return () => clearTimeout(timer);
  }, [key]);

  return { preview, loading, error };
}

export function useEmailFormPreview(
  form: EmailFormData,
  catalog: EmailVariablesCatalog | null,
  agendamentoId?: string,
) {
  const padrao = catalog?.templatePadrao;
  const custom = form.mode === "custom";
  const params =
    form.enabled && padrao
      ? {
          ...(agendamentoId ? { agendamentoId } : {}),
          assunto: custom && form.assunto.trim() ? form.assunto : padrao.assunto,
          corpo: custom && form.corpo.trim() ? form.corpo : padrao.corpo,
        }
      : null;
  return useEmailPreview(params);
}

export function useEmailHealth() {
  const [healthy, setHealthy] = useState(true);
  useEffect(() => {
    let alive = true;
    checkEmailHealth().then((ok) => alive && setHealthy(ok));
    return () => {
      alive = false;
    };
  }, []);
  return healthy;
}
